import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export class ProductEstimateMixin extends Vue {
  public async fixAppointment(_event?: MouseEvent): Promise<void> {
    return;
  }
}
